/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCollector: {
  name: 'collector';
  data: string;
} = {
  name: 'collector',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 .5A3.5 3.5 0 0 0 2.5 4v1a.5.5 0 0 0 1 0V4a2.5 2.5 0 0 1 5 0v8a2.5 2.5 0 0 1-5 0v-1a.5.5 0 0 0-1 0v1a3.5 3.5 0 1 0 7 0V4A3.5 3.5 0 0 0 6 .5Zm6.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.793 8.5H11a.5.5 0 0 1 0-1h2.793l-1.147-1.146a.5.5 0 0 1 0-.708ZM.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 8Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
